import { Cascader } from 'antd'
import { useEffect, useState } from 'react'
import './SelectOption.scss'
import { getStroage } from 'utils'

export const SelectOption = ({ value, onChange, title, dictData, setIsmodifyTable }) => {
    const [selectedValue, setSelectedValue] = useState()
    const [options, setOptions] = useState()

    useEffect(() => {
        switch (title) {
            case 'type':
                setOptions(dictData[0]?.data?.data)
                setSelectedValue(value)
                break
            case 'unit':
                setOptions(dictData[1]?.data?.data)
                setSelectedValue(value)
                break
            case 'useType':
                setOptions(dictData[2]?.data?.data)
                setSelectedValue(value)
                break
            case 'HazardousType':
                setOptions(dictData[3]?.data?.data)
                setSelectedValue(value)
                break
            case 'areaType':
                setOptions(dictData[4]?.data?.data)
                setSelectedValue(value)
                break
            case 'lineType':
                setOptions(dictData[5]?.data?.data)
                setSelectedValue(value)
                break
            case 'observer':
                setOptions(dictData)
                setSelectedValue(value)
                break
            case 'windSpeedUnit':
                setOptions(dictData[4]?.data?.data)
                setSelectedValue(value)
                break
            default:
        }
    }, [])

    useEffect(() => {
        onChange(selectedValue)
    }, [selectedValue])

    // 渲染下拉菜单
    const generateOptionsWithKey = (options, parentId = null, index = 0) => {
        return options?.map(item => ({
            key: getStroage('language') === 'zh' ? item?.dictLabel : item?.dictLabelEn,
            label: (
                <div>
                    <span className='dictColor' style={{ backgroundColor: item?.listClass }}></span>
                    <span>{getStroage('language') === 'zh' ? item?.dictLabel : item?.dictLabelEn}</span>
                </div>
            ),
            dictColor: item?.listClass,
            value: item.dictValue,
        }))
    }

    return (
        <div>
            <Cascader
                value={selectedValue}
                options={generateOptionsWithKey(options)}
                onChange={value => {
                    setIsmodifyTable(true)
                    setSelectedValue(value[0])
                }}
                showSearch={{
                    filter: (inputValue, path) =>
                        path.some(option => option.key.toLowerCase().indexOf(inputValue.toLowerCase()) > -1),
                    render: (inputValue, option) =>
                        option.map((item, index) => {
                            return (
                                <div key={index}>
                                    <span className='dictColor' style={{ backgroundColor: item?.dictColor }}></span>
                                    <span>{item?.key}</span>
                                </div>
                            )
                        }),
                    matchInputWidth: true,
                }}
                allowClear={true}
                onClear={() => {
                    setSelectedValue(null)
                    onChange(null) // 清空时强制设为空
                }}
            />
        </div>
    )
}
